import { License } from "@budibase/types"

export interface CachedLicense extends License {
  refreshedAt?: string
}

// Middleware

export interface LicenseMiddlewareOptions {
  checkUsersLimit: boolean
  licensingCheck?: (ctx: any) => boolean
  populateLicense?: (tenantId: string) => Promise<License | undefined>
  populateFreeLicense?: (ctx: any, tenantId: string) => License
}

// Cache

export interface GetCachedLicenseOptions {
  populateLicense?: (tenantId: string) => Promise<License | undefined>
  populateFreeLicense?: (ctx: any, tenantId: string) => License
}
